import parseISO from 'date-fns/parseISO';

import withStyles from '@mui/styles/withStyles';

import Typography from '@classify/react-core-components/Typography';
import defaultTranslations from '../../constants/defaultTranslations';

const styles = /* istanbul ignore next */ ({ breakpoints, palette, typography }) => {
  const subtitle1 = { ...typography.subtitle1 };
  const h5 = { ...typography.h5 };

  delete subtitle1.color;
  delete h5.color;
  delete subtitle1[breakpoints.down('sm')]?.color;
  delete h5[breakpoints.down('sm')]?.color;

  return {
    root: {
      position: 'absolute',
      zIndex: 1,
      left: 0,
      top: 0,
      bottom: 0,
      right: 0,
      backgroundColor: 'rgba(0,0,0,.56)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    },
    disabled: {
      backgroundColor: 'rgba(255,255,255,.86)',
      '& $text': {
        color: palette.text.inactive,
      },
    },
    text: {
      ...subtitle1,
      color: palette.text.onContrasted,
      fontWeight: typography.fontWeightMedium,
      [breakpoints.up('sm')]: {
        ...h5,
      },
    },
  };
};

function getSeasonYear(season, year) {
  if (season === 'winter') {
    return `${year}-${year + 1}`;
  }

  return year;
}

export function ReleaseDate({
  classes = {},
  openedAt = null,
  releaseSeason = '',
  releaseYear = 0,
  translations = defaultTranslations,
  locale = 'en',
}) {
  const getSeasonLabel = (season, year) => {
    switch (season) {
      case 'spring':
        return translations.releaseSpring(year);
      case 'summer':
        return translations.releaseSummer(year);
      case 'fall':
        return translations.releaseFall(year);
      case 'winter':
        return translations.releaseWinter(year);
      /* istanbul ignore next */
      default:
        return null;
    }
  };

  const renderInFuture = (openDate, className) => {
    let stringifiedDate;

    /* istanbul ignore next */
    if (!openDate.toLocaleDateString) {
      stringifiedDate = openDate.toDateString();
    } else {
      const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };

      stringifiedDate = openDate.toLocaleDateString(locale, dateOptions);
    }

    return (
      <Typography variant="subheadingSmall" className={className}>
        {translations.releaseDateOpening}
        <br />
        <span>{stringifiedDate}</span>
      </Typography>
    );
  };

  const renderNextSeason = (className) => {
    const seasonLabel = getSeasonLabel(releaseSeason, getSeasonYear(releaseSeason, releaseYear));

    if (!seasonLabel) {
      return null;
    }

    return (
      <Typography variant="subheadingSmall">
        <span
          className={className}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: seasonLabel }}
        />
      </Typography>
    );
  };

  let render;
  let isSeasonOpening = false;

  if (openedAt) {
    const nowTime = new Date().getTime();
    const openDate = parseISO(openedAt);
    const openingTime = openDate.getTime();
    const openingInFuture = openingTime > nowTime;

    render = openingInFuture ? renderInFuture(openDate, classes.text) : null;
  } else {
    isSeasonOpening = true;
    render = renderNextSeason(classes.text);
  }

  return render ? (
    <div className={`${classes.root} ${isSeasonOpening ? classes.disabled : ''}`}>{render}</div>
  ) : null;
}

export default withStyles(styles)(ReleaseDate);
